import { useQuery } from '@tanstack/react-query';

import { useContractApi } from '~/data/api';
import { useDriveFile } from '~/data/appApi';

export const useContractFile = ({ contractNumber }: { contractNumber: string }) => {
  const { getContractFile } = useContractApi();
  const { getFile } = useDriveFile();

  const contractUrl = useQuery({
    queryFn: () => getContractFile({ contractNumber }),
    queryKey: ['contractFileUrl', contractNumber],
  });

  const contractFile = useQuery({
    enabled: !!contractUrl.data?.contractDownloadUrl,
    queryFn: () => getFile({ fileUrl: contractUrl.data!.contractDownloadUrl }),
    queryKey: ['contractBlob', contractNumber],
  });

  return {
    data: contractFile.data?.fileContent,
    downloadUrl: contractUrl.data?.contractDownloadUrl,
    error: contractFile.error || contractUrl.error,
    isError: contractFile.isError || contractUrl.isError,
    isLoading: contractFile.isLoading || contractUrl.isLoading,
    isSuccess: contractFile.isSuccess && contractUrl.isSuccess,
  };
};
